// extracted by mini-css-extract-plugin
export default {"form":"BRzHskTfHjV2hK1F1G7T"};